module.exports = __webpack_public_path__ + "img/0011.67d1bde2.png";